// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_c900e04","empty":"_a4f0c79","unregisterButton":"_3684e5e"};